import * as yup from "yup";

import { I18n } from "aws-amplify";

import {
  validateCnpj,
  validateCpf,
} from "../../form/form-factory/utils/validations";

export const getValidationSchemaByName = (name: string): any => {
  if (!Array.isArray(name)) {
    switch (name) {
      case "photoRequired":
        return yup.string().required("Foto obrigatório");
      case "inputRequired":
        return yup.string().required("Campo obrigatório");
      case "currencyCodeRequired":
        return yup
          .string()
          .required("Campo obrigatório")
          .length(3, "Deve ter exatamente 3 caracteres");
      case "objectRequired":
        return yup.object().required("Campo obrigatório");
      case "emailRequired":
        return yup
          .string()
          .email("Email inválido")
          .required("Campo obrigatório");
      case "passwordMinRequired":
        return yup
          .string()
          .min(8, "Senha pequena")
          .required("Campo obrigatório");
      case "passwordWithMatches":
        return yup
          .string()
          .required("Campo obrigatório")
          .min(8, "Senha pequena")
          .max(24, "Senha muito grande")
          .matches(/[a-z]/, "Ao menos uma letra minúscula")
          .matches(/[A-Z]/, "Ao menos uma letra maiúscula")
          .matches(/[0-9]/, "Ao menos um número")
          .matches(
            /[!@#$%*()_/\\\-+^&{}:;?.]/,
            "Ao menos um caractere especial",
          );
      case "confirmPassword":
        return yup.string().when("password", {
          is: (val: any) => val && val.length >= 8,
          then: yup
            .string()
            .oneOf([yup.ref("password")], "As senhas não são iguais")
            .required("Campo obrigatório"),
        });
      case "inputRequiredCode":
        return yup
          .string()
          .required("Campo obrigatório")
          .matches(/[0-9]/, "Apenas números");
      case "cpfValidation":
        return yup
          .string()
          .required(I18n.get("ValidateRequiredField"))
          .test("cpf-validation", I18n.get("ValidateInvalidCPF"), (value) =>
            validateCpf(value),
          );
      case "cnpjValidation":
        return yup
          .string()
          .required(I18n.get("ValidateRequiredField"))
          .test("cnpj-validation", "CNPJ Inválido", (value) =>
            validateCnpj(value),
          );
      case "dateFromToday":
        return yup.string()
          .required(I18n.get("ValidateRequiredField"))
          .test(
            "date-from-today",
            "A data deve ser a partir de hoje",
            (value) => {
              if (!value) return false;
              const selectedDate = new Date(value);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              selectedDate.setHours(0, 0, 0, 0);
              return selectedDate >= today;
            },
          );
      case "dateFromTodayNotRequired":
        return yup.string().test(
          "date-from-today",
          "A data deve ser a partir de hoje",
          (value) => {
            if (!value) return true;
            const selectedDate = new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            return selectedDate >= today;
          },
        );
      case "inputRequiredWhenCertificate":
        return yup.string().when("certificate", {
          is: (val: any) => val instanceof File,
          then: yup.string().required("Campo obrigatório quando há certificado"),
        });
      case "emailRequiredWhenCertificate":
        return yup
          .string()
          .email("Email inválido")
          .when("certificate", {
            is: (val: any) => val instanceof File,
            then: yup
              .string()
              .email("Email inválido")
              .required("Campo obrigatório quando há certificado"),
          });
      default:
        throw new Error(`Validation ${name} don't found`);
    }
  }

  return null;
};
